export default __webpack_public_path__ + "static/blissfulGuilty-69010cbf002dcbd12cff2a966ec58538.svg";